import { dingtalkApi } from "../http-serve/dingtalkApi";
import { ApiCorpMethods } from "../http-serve/corp/http-methods";

const PERSON = 0, GROUP = 1;
/**
 * 实名窗口
 * @param { number } type  0 联系管理员； 1 企业认证； 2 个人认证
 */
let showed = false;

export function authPup (type) {
  let { userType } = getApp().data.currentUserInfo;
  let content = type == 2 ? '您还未完成实名认证，认证完成后才能执行该操作！' : `当前企业还未完成实名认证，${type == 0 ? '请联系管理员完成认证！' : '认证完成后才能执行该操作！'}`,
    confirmButtonText = type == 0 ? '联系管理员' : type == 2 ? '立即激活' : '立即认证';
  if (showed) return false
  if (type == 1 && userType === PERSON) content = '当前企业还未完成实名认证，请及时完善资料或联系管理员处理。'
  showed = true
  dd.confirm({
    title: '提示',
    content,
    confirmButtonText,
    cancelButtonText: '取消',
    success: (reslut) => {
      // console.log('comfirm',reslut);
      showed = false
      // 联系管理员
      if (reslut.confirm) {
        const AuthInfo = dd.getStorageSync({ key: 'AuthInfo' }).data;
        if (type == 0) {
          dingtalkApi.entVerify({
            corpId: dd.corpId,
            dingTalkUserId: AuthInfo.dingTalkUserId
          }).then(res => {
            let text = res.success ? '消息发送成功，请等待管理员操作' : res.description
            dd.alert({ content: text, buttonText: '确认' })
          })
        }
        // 企业认证
        if (type == 1) dd.navigateTo({ url: "/pages/certification/certification" })
        // 个人认证
        if (type == 2) dd.navigateTo({ url: "/pages/certification/person/person" })
      }
    },
  });
}

/** 钉钉事件日志回调
 * @param desc 操作详情
 * @param module 操作模块ID
 * @module 0 成员管理 / 第三方同步数据
 * @module 1 角色管理
 * @module 2 组织管理
 * @module 3 签章管理
 * @module 4 合同管理
 * @module 5 模板管理
 * @module 6 审批流程管理
*/
export function callbackLog (param) {
  // const { desc, module } = param
  ApiCorpMethods.LogController.dingTalkCorpOperationLog(param).then(res => {
    console.log('钉钉事件日志回调', res);
  })
}
/** true pc端 false 移动端 */
let Agents = [
  "Android",
  "iPhone",
  "SymbianOS",
  "Windows Phone",
  "OpenHarmony",
  "HarmonyOS",
  "iPad",
  "iPod",
];
export function IsPc () {
  let userAgentInfo = window.navigator.userAgent;
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  if (/(?=.*(\(PC;|Windows\s+NT))(?=.*(huawei|harmony|arkweb|htbrowser))/i.test(userAgentInfo)) {
    flag = true;
  }
  return flag; // true pc端 false 移动端
}
/**
 * 通用脱敏方法
 * @param {string} value - 待脱敏的字符串
 * @param {string} type - 类型: 'idCard' | 'bankCard' | 'phone'
 * @returns {string} 脱敏后的字符串
 */
export function desensitizeIdCard(value, type) {
  if (!value || typeof value !== 'string') return value
  const str = value.replace(/\s/g, '')
  // 根据类型确定保留位数
  const config = {
    idCard: { keepStart: 6, keepEnd: 4 },
    bankCard: { keepStart: 6, keepEnd: 4 },
    phone: { keepStart: 3, keepEnd: 4 }
  }
  const rule = config[type]
  if (!rule) return value
  const { keepStart, keepEnd } = rule
  const totalLen = keepStart + keepEnd
  if (str.length < totalLen) return str
  return str.substring(0, keepStart) + '****' + str.substring(str.length - keepEnd)
}



// WEBPACK FOOTER //
// ./assets/js/utils/publicMethods.js